import Vue from "vue";

import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import i18n from '@/langs';
import 'amfe-flexible'
import "@/assets/css/index.css";
import { isMobile } from "@/utils"
import { Toast } from 'vant';

Vue.config.productionTip = false;

if (isMobile()) {
  document.querySelector('html').removeAttribute('class')
}

Vue.use(Toast);

new Vue({
  router,
  Toast,
  store,
  i18n,
  render: h => h(App),
  mounted() {
   
  }
}).$mount("#app");

